var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.817,
    height: 11.919,
    viewBox: "0 0 18.817 11.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2f394e;stroke:#2f394e;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.283 -53.047)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.055,58.7H1.031L5.9,53.833a.3.3,0,0,0-.422-.423L.1,58.789a.3.3,0,0,0,0,.423h0l5.378,5.378a.3.3,0,1,0,.43-.415L5.9,64.168,1.031,59.3H14.055a.3.3,0,0,0,0-.6Z",
    transform: "translate(-0.011 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.678,64.677a.3.3,0,0,1-.212-.087L.087,59.212a.3.3,0,0,1,0-.423l5.378-5.379a.3.3,0,0,1,.423.422L.722,59l5.167,5.167a.3.3,0,0,1-.211.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.911,245.783H.389a.308.308,0,1,1,0-.6H17.911a.308.308,0,1,1,0,.6Z",
    transform: "translate(-0.008 -186.484)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.3e461353.svg";
export { ForwardRef as ReactComponent };